module.exports = __webpack_public_path__ + "img/files-download-file.577b7378.svg";